<template>
  <v-text-field v-model="val"
                v-on:blur="validateHour()"
                :placeholder="datalabel"
                :hide-details="hideDetails"
                :disabled="readonly"
                mask="##:##"
                return-masked-value></v-text-field>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    validateHour() {
      if (!this.val || this.val.length < 5) {
        this.val = "";
        return;
      }

      let validHour = moment(this.val, "HH:mm", true).isValid();

      if (!validHour) {
        this.val = "";
      }
    },
  },

  props: {
    datalabel: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },

    value: {},
  },

  computed: {
    val: {
      get() {
        return this.value;
      },

      set(value) {
        if (!this.readonly) this.$emit("input", value);
      },
    },
  },

  watch: {
    menu(value) {
      if (value && this.readonly) this.$nextTick(() => (this.menu = false));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.v-text-field {
  font-weight: 500;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 0 !important;

  ::v-deep .v-input__slot {
    margin: 0;
  }

  &.v-input {
    ::v-deep input {
      padding-bottom: 0 !important;
      color: #707070;
      font-weight: 600;
    }
  }

  &[center] {
    ::v-deep input {
      text-align: center;
    }
  }

  &:before {
    border-style: unset;
    display: none;
  }
}
</style>
